import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, X } from "lucide-react";

interface MobileStickyCTAProps {
  onLaunchApp: () => void;
}

export default function MobileStickyCTA({ onLaunchApp }: MobileStickyCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px down
      if (window.scrollY > 300 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 300) {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDismissed]);

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden animate-slide-up">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-2xl border-t-2 border-white/20">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            <div className="flex-1">
              <p className="text-sm font-semibold">Start Free Today</p>
              <p className="text-xs text-blue-100">No credit card required</p>
            </div>
            <Button
              onClick={onLaunchApp}
              className="bg-white text-blue-600 hover:bg-blue-50 font-bold shadow-lg flex-shrink-0"
              size="sm"
            >
              Get Started
              <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <button
              onClick={() => setIsDismissed(true)}
              className="text-white/80 hover:text-white p-1"
              aria-label="Dismiss"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
